import { parseJSON } from "../../helpers/json";
import { API_ENDPOINT } from '../../constants';

const REFUND_API_BASE = API_ENDPOINT;

const authHeaders = () => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
});

const extractListPayload = (result) => {
    if (!result) {
        return { items: [], total: 0, pagination: { page: 0, limit: 20, total: 0, totalPages: 0 } };
    }
    if (Array.isArray(result)) {
        return {
            items: result,
            total: result.length,
            pagination: { page: 0, limit: result.length || 20, total: result.length, totalPages: 1 }
        };
    }
    const items = Array.isArray(result.data)
        ? result.data
        : Array.isArray(result.items)
            ? result.items
            : Array.isArray(result.result)
                ? result.result
                : [];
    const pagination = result.pagination || {
        page: result.page ?? 0,
        limit: result.limit ?? items.length,
        total: result.total ?? items.length,
        totalPages: result.totalPages ?? 1
    };
    return { items, total: pagination.total ?? items.length, pagination };
};

export default {
    'api1': {
        onLoad: true,
        action: (lang, match, query) => {
            const page = Number(query.page) || 0;
            const limit = Number(query.entries) || 20;
            const sortField = query.sortField || undefined;
            const sortType = query.sortType !== undefined && query.sortType !== null && query.sortType !== ''
                ? Number(query.sortType)
                : undefined;
            const params = new URLSearchParams();
            params.set('page', page);
            params.set('limit', limit);
            if (query.status) params.set('status', query.status);
            if (query.shopifyOrderId) params.set('shopifyOrderId', query.shopifyOrderId);
            if (sortField) params.set('sortField', sortField);
            if (sortType !== undefined) params.set('sortType', sortType);

            return fetch(`${REFUND_API_BASE}/data/refund-events`, {
                method: 'POST',
                headers: authHeaders(),
                body: JSON.stringify({
                    page,
                    limit,
                    status: query.status || undefined,
                    shopifyOrderId: query.shopifyOrderId || undefined,
                    sortField,
                    sortType,
                })
            }).then(parseJSON).then(({ result, status }) => {
                if (status >= 200 && status < 300) {
                    return extractListPayload(result);
                }
                return { items: [], total: 0, pagination: { page: 0, limit: 20, total: 0, totalPages: 0 } };
            });
        }
    },
    'reset-event': {
        onLoad: false,
        action: (data) => {
            const { id } = data;
            return fetch(`${REFUND_API_BASE}/data/refund-events/reset-event`, {
                method: 'POST',
                headers: authHeaders(),
                body: JSON.stringify({
                  id
                })
            }).then(parseJSON).then(({ result, status }) => ({ result, status }));
        }
    },
    'mark-resolved': {
        onLoad: false,
        action: (data) => {
            const { id } = data;
            return fetch(`${REFUND_API_BASE}/data/refund-events/mark-resolved`, {
                method: 'POST',
                headers: authHeaders(),
                body: JSON.stringify({ id })
            }).then(parseJSON).then(({ result, status }) => ({ result, status }));
        }
    }
};
